<script setup lang="ts">
defineOptions({ name: 'SsoLoginPage' })
import { onMounted } from 'vue'
import { initSso } from './sso'
import AuthEmail from './components/AuthEmail.vue'
import AuthRememberedUser from './components/AuthRememberedUser.vue'
import AuthPassword from './components/AuthPassword.vue'
import AuthSetup from './components/AuthSetup.vue'
import AuthCode from './components/AuthCode.vue'
import AuthPortal from './components/AuthPortal.vue'
const { step, formError, links, isSessionChecked, loadCurrentSession } = initSso()

onMounted(loadCurrentSession)
</script>
<template>
  <v-theme-provider theme="sso">
    <div v-if="!isSessionChecked" class="sso-page sso-page--checking">
      <v-progress-circular indeterminate></v-progress-circular>
    </div>
    <auth-portal v-else-if="step === 'portal'"></auth-portal>
    <div
      v-else
      class="sso-page"
      :class="{
        'sso-page--setup': step === 'setup',
        'sso-page--mfa': step === 'mfa',
      }">
      <div class="sso-page__main">
        <header class="sso-brand">
          <div class="sso-brand__name">BEST LEASING</div>
          <div class="sso-brand__description">
            Єдиний вхід до корпоративних систем
          </div>
          <div class="sso-brand__company">ТОВ «БЕСТ ЛІЗИНГ»</div>
        </header>

        <v-card
          color="white"
          class="sso-card"
          :class="{
            'sso-card--compact': step === 'setup' || step === 'mfa',
          }"
          elevation="12"
          rounded="xl"
          tag="main">
          <h1
            class="sso-card__title"
            :class="{
              'sso-card__title--secondary': step === 'setup' || step === 'mfa',
            }">
            Вхід до корпоративних систем
          </h1>

          <v-alert
            v-if="formError"
            class="sso-alert"
            color="error"
            density="compact"
            icon="mdi-alert-circle-outline"
            variant="tonal">
            {{ formError }}
          </v-alert>

          <auth-remembered-user v-if="step === 'account'"></auth-remembered-user>
          <auth-email v-else-if="step === 'email'"></auth-email>
          <auth-password v-else-if="step === 'password'"></auth-password>
          <auth-setup v-else-if="step === 'setup'"></auth-setup>
          <auth-code v-else-if="step === 'mfa'"></auth-code>
          <div
            v-if="step === 'account' || step === 'email' || step === 'password'"
            class="sso-secure">
            <div class="sso-secure__primary">
              <v-icon icon="mdi-lock-outline" size="17"></v-icon>
              <div>
                Єдиний захищений вхід<span class="sso-secure__desktop-suffix">
                  до корпоративних систем</span
                >
              </div>
            </div>
            <div class="sso-secure__caption">SSO · Single Sign-On</div>
          </div>
        </v-card>
      </div>

      <footer class="sso-footer">
        <div class="sso-footer__legal">
          <a v-if="links.privacy" :href="links.privacy"
            >Політика обробки персональних даних</a
          >
          <span>© 2026 ТОВ «БЕСТ ЛІЗИНГ»</span>
        </div>
        <v-btn
          v-if="links.support"
          :href="links.support"
          aria-label="Служба підтримки"
          class="sso-support"
          icon="mdi-help-circle-outline"
          variant="text"></v-btn>
      </footer>
    </div>
  </v-theme-provider>
</template>
<style lang="scss" src="./sso.scss"></style>
